// extracted by mini-css-extract-plugin
export var actionButton = "_aw-1";
export var actionButtons = "_aw-2";
export var actions = "_aw-0";
export var aiUnread = "_aw-10";
export var alignCenter = "_aw-h";
export var backWrapper = "_aw-3";
export var cellContainer = "_aw-4";
export var checkboxContainer = "_aw-5";
export var contentContainer = "_aw-6";
export var contentHeader = "_aw-8";
export var conversationsTableWrapper = "_aw-s";
export var draftReplyBadgeContainer = "_aw-m";
export var dropdownItem = "_aw-b";
export var dropdownItemsContainer = "_aw-a";
export var dropdownTitle = "_aw-c";
export var errorIcon = "_aw-7";
export var filter = "_aw-d";
export var gray = "_aw-i";
export var headerActionButtons = "_aw-e";
export var headerCheckboxContainer = "_aw-f";
export var icon = "_aw-j";
export var menuContainer = "_aw-k";
export var noMoreTicketsIcon = "_aw-12";
export var noMoreTicketsSubText = "_aw-13";
export var oneLine = "_aw-l";
export var optionsButton = "_aw-n";
export var plus = "_aw-o";
export var portalButtonsWrapper = "_aw-g";
export var red = "_aw-p";
export var scrolledTop = "_aw-9";
export var search = "_aw-q";
export var selectedConversationsCount = "_aw-r";
export var spinner = "_aw-t";
export var strong = "_aw-u";
export var summaryCell = "_aw-v";
export var tableContainer = "_aw-11";
export var tagContainer = "_aw-w";
export var threeDots = "_aw-x";
export var twoLines = "_aw-y";
export var unread = "_aw-z";